import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output, computed } from '@angular/core';

import { EpcotConfigService } from '../common/epcot-config.service';

@Component({
    selector: 'ms-video-pin',
    templateUrl: 'video-pin.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class VideoPinComponent {
    @HostBinding('class.pinned')
    @Input()
    isPinned: boolean;

    @HostBinding('class.video-pin')
    class = true;

    @HostBinding('class.disabled')
    @Input()
    disabled: boolean;

    @Output()
    toggle = new EventEmitter<void>();

    @HostListener('click')
    onClick(): void {
        if (!this.disabled) {
            this.toggle.emit();
        }
    }

    readonly isEpcotEnabled = computed(() => this.epcotConfigService.isEnabled());

    constructor(private epcotConfigService: EpcotConfigService) {}
}
